import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import useFriendsPhotos from 'src//hooks/useFriendsPhotos';
import BlurredUserPhotos from 'src/components/BlurredUserPhotos';
import { useDirectMessageNavigation } from 'src/components/DirectMessage/context';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
import { ProfileImageContainer, ActionButton, Container, NameWrap, ProfileInfo, Name } from './styles';
const StyledBlurredPhotos = styled(BlurredUserPhotos)`
  color: ${({
  theme
}) => theme.color.surface2};
`;
type Props = Pick<ComponentProps<'li'>, 'className'>;
const FollowMoreCard = ({
  ...props
}: Props) => {
  const {
    t
  } = useTranslation();
  const {
    openFollowing
  } = useDirectMessageNavigation();
  const profileImages = useFriendsPhotos(2);
  const handleClickButton = () => {
    pushEvent({
      eventType: EVENT_TYPE.LOG,
      eventName: EVENT_NAME.MESSAGE__OPEN_FOLLOW,
      eventParams: {
        action_category: 'open',
        tab: 'message',
        page: 'following',
        target: 'follow',
        referrer: 'see_all'
      }
    });
    openFollowing();
  };
  return <Container {...props} data-sentry-element="Container" data-sentry-component="FollowMoreCard" data-sentry-source-file="More.tsx">
      <ProfileInfo data-sentry-element="ProfileInfo" data-sentry-source-file="More.tsx">
        <ProfileImageContainer data-sentry-element="ProfileImageContainer" data-sentry-source-file="More.tsx">
          <StyledBlurredPhotos containerWidth={80} offset={10} images={profileImages} data-sentry-element="StyledBlurredPhotos" data-sentry-source-file="More.tsx" />
        </ProfileImageContainer>
        <NameWrap data-sentry-element="NameWrap" data-sentry-source-file="More.tsx">
          <Name data-sentry-element="Name" data-sentry-source-file="More.tsx">{t('MESSAGE_FOLLOWING_MORE_CARD_DESC')}</Name>
        </NameWrap>
      </ProfileInfo>
      <ActionButton type='button' size='small' variant='secondary' onClick={handleClickButton} data-sentry-element="ActionButton" data-sentry-source-file="More.tsx">
        {t('MESSAGE_FOLLOWING_MORE_CARD_BUTTON')}
      </ActionButton>
    </Container>;
};
export default FollowMoreCard;